import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    // get theme from user's system preferences
    // dark: window.matchMedia('(prefers-color-scheme: dark)').matches,
    // get the theme from the local storage
    dark: localStorage.getItem('isDarkTheme') === 'true',
    themes: {
      dark: {
        // primary: colors.deepPurple.lighten2,
        primary: colors.red.lighten1,
        // secondary: colors.pink.lighten4,
        accent: colors.blue,
        error: '#b71c1c',
        background: colors.grey.dark // Not automatically applied

      },
      light: {
        // primary: colors.deepPurple.accent3,
        primary: colors.red,
        // primary: '#D7221A',
        // #F54641 is used for undraw images

        secondary: colors.grey.lighten5,
        accent: colors.blue,
        error: '#b71c1c'
        // background: colors.grey.lighten5 // Not automatically applied

      }
    }
  }
})
